import {
  GEOGRAPHY_PAGE_TAB_IDENTIFIERS,
  REGION_FEATURES,
  type GeographyPageFeatures,
  type RegionFeatures,
} from '@schema/featureToggle'
import { regionTabs } from './constants'

const geographyPageTabValues = new Set<string>(
  Object.values(GEOGRAPHY_PAGE_TAB_IDENTIFIERS),
)

const regionFeatureValues = new Set<string>(Object.values(REGION_FEATURES))

export const isRegionFeature = (
  tab: GeographyPageFeatures,
): tab is RegionFeatures => regionFeatureValues.has(tab)

export const resolveRegionPageTab = (
  tab: GeographyPageFeatures,
): RegionFeatures => (isRegionFeature(tab) ? tab : REGION_FEATURES.overview)

/** Region tab keys mapped to localized URL path segments */
const regionPageTabUrlSegmentByTab: Partial<Record<RegionFeatures, string>> = {
  [regionTabs.current]: 'actueel',
  [regionTabs.discussion]: 'discussie',
  [regionTabs.initiatives]: 'initiatieven',
  [regionTabs.municipalities]: 'gemeenten',
  [regionTabs.knowledgeHub]: 'kennishub',
}

const regionPageTabByUrlSegment = Object.fromEntries(
  Object.entries(regionPageTabUrlSegmentByTab).map(([tab, segment]) => [
    segment,
    tab,
  ]),
) as Record<string, RegionFeatures>

export const regionPageTabToUrlSegment = (tab: string): string =>
  regionPageTabUrlSegmentByTab[tab as RegionFeatures] ?? tab

export const parseRegionPageTab = (
  tab: string | undefined | null,
): GeographyPageFeatures => {
  if (tab && regionPageTabByUrlSegment[tab]) {
    return regionPageTabByUrlSegment[tab]
  }
  if (tab && geographyPageTabValues.has(tab)) {
    return tab as GeographyPageFeatures
  }
  return GEOGRAPHY_PAGE_TAB_IDENTIFIERS.overview
}
